// @ts-nocheck
import createOfferingListWidget from './createOfferingListWidget';
import { isResponsiveEditor } from '@wix/santa-editor-utils';
export default ({ editorAPI }) =>
  createOfferingListWidget({
    editorAPI,
    isEditorX: isResponsiveEditor(),
  });
